import { css } from '../../../styled-components';
import { mgbStyles } from './button.styles.mgb';
export const sportxxStyles = css`
  ${mgbStyles}

  font-family: "Proxima Nova Condensed", Helvetica, "Helvetica Neue", Arial, sans-serif;
  font-style: normal;
  font-weight: ${({
  theme: {
    fonts
  }
}) => fonts.weights.semiBold};
`;